import { render, staticRenderFns } from "./TableInstances.vue?vue&type=template&id=960be452&"
import script from "./TableInstances.vue?vue&type=script&lang=js&"
export * from "./TableInstances.vue?vue&type=script&lang=js&"
import style0 from "./TableInstances.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports